import { service, localStorageAdapter, } from '@/services/app.service';
import CustomerModel from '@/models/CustomerModel';
import * as _ from 'lodash';
import OfferModel from '@/models/loyalty/OfferModel';
var customerKey = 'customer';
var customerService = {
    login: function (loginQuery) {
        var loginEndpoint = "/admin/squib_customer_login?lb=" + loginQuery.lb + "&cmd=" + loginQuery.cmd;
        if (loginQuery.phone) {
            loginEndpoint = loginEndpoint + ("&phone=" + loginQuery.phone);
        }
        if (loginQuery.token) {
            loginEndpoint = loginEndpoint + ("&token=" + loginQuery.token + "&loyalty_add=1&channel=5");
        }
        return service.post(loginEndpoint, null);
    },
    addDeliveryAddress: function (addressInfo) {
        if (!addressInfo.cb) {
            return false;
        }
        var addressEndpoint = "/admin/squib_address";
        return service.get(addressEndpoint, {
            params: {
                address: addressInfo.address,
                apt_num: addressInfo.aptNum,
                b: addressInfo.b,
                cb: addressInfo.cb,
                cmd: addressInfo.cmd,
                formatted_address: addressInfo.formatted_address,
                latitude: addressInfo.latitude,
                longitude: addressInfo.longitude,
                name: addressInfo.name,
                note: addressInfo.note,
                phone: addressInfo.phone,
            }
        });
    },
    deleteAddress: function (apiReq) {
        return service.get("/admin/squib_address?cmd=" + apiReq.cmd + "&cb=" + apiReq.cb + "&id=" + apiReq.id);
    },
    verifyLoginStatus: function (customerId) {
        if (!customerId) {
            customerId = '';
        }
        return service.get("/admin/squib_verify_login?cb=" + customerId);
    },
    getCustomerOnLogin: function (customerRaw) {
        var customer = new CustomerModel(customerRaw);
        return customer;
    },
    getLoyaltyInfo: function (customer) {
        if (!customer) {
            return null;
        }
        var loyaltyInfo = customer.loyaltyInfo;
        if (loyaltyInfo) {
            return loyaltyInfo;
        }
        return null;
    },
    getLoyaltyPoints: function (customer) {
        var loyaltyInfo = customerService.getLoyaltyInfo(customer);
        if (!loyaltyInfo) {
            return 0;
        }
        var loyaltyPointsArray = _.flatMap(loyaltyInfo, function (info) {
            return info.points;
        });
        var points = loyaltyPointsArray.reduce(function (accumulator, loyaltyModel) {
            if (loyaltyModel) {
                var pointsEarned = loyaltyModel.loyaltyPointsEarned;
                var pointsSpent = loyaltyModel.loyaltyPointsSpent;
                return accumulator + (pointsEarned - pointsSpent);
            }
            return accumulator;
        }, 0);
        return points;
    },
    editProfile: function (profile) {
        var squibCall = "admin/squib_save_customer?lb=" + profile.lb;
        if (profile.newPhone) {
            squibCall += "&cmd=update_phone&phone=" + profile.newPhone;
        }
        var formData = new FormData();
        formData.append("c", JSON.stringify(profile.c));
        if (profile.cmd) {
            squibCall += "&cmd=" + profile.cmd;
        }
        return service.post(squibCall, formData, {
            withCredentials: true,
        });
    },
    setCustomerForStorage: function (customer) {
        localStorageAdapter.setItem(customerKey, customer);
    },
    getCustomerFromStorage: function () {
        var customer = localStorageAdapter.getItem(customerKey);
        return customer;
    },
    generateCustomerOffers: function (customer, franchisor) {
        var customerLoyaltyPoints = this.getLoyaltyPoints(customer);
        var rewardPointsNeeded = franchisor.loyaltyPointsPerReward;
        var offers = [];
        if (rewardPointsNeeded <= customerLoyaltyPoints && franchisor.loyaltyVisitsReward) {
            var offersAvailable = Math.floor(customerLoyaltyPoints / rewardPointsNeeded);
            var offer = franchisor.loyaltyVisitsReward;
            for (var i = 0; i < offersAvailable; i++) {
                var rewardOffer = _.cloneDeep(offer);
                rewardOffer.id = (!offer.rewardId && offer.rewardFlags === 2) ? offer.base + "~" + offer.name + "~" + i : offer.id;
                rewardOffer.rewardId = Math.floor(Math.random() * 90000) * (i + 1000);
                offers.push(rewardOffer);
            }
        }
        return offers;
    },
    convertAllCustomerOffers: function (customer, franchisor, customerOffers) {
        var offers = [];
        if (customerOffers && customerOffers.length) {
            offers = customerOffers.map(function (offer) { return new OfferModel(offer); });
        }
        if (franchisor && customer) {
            offers = offers.concat(customerService.generateCustomerOffers(customer, franchisor));
        }
        return offers;
    },
    sendVoicePin: function () {
        var squibCall = "admin/login_send_voice_pin";
        return service.get(squibCall, {
            withCredentials: true,
        });
    },
    validateCustomer: function (customerBase) {
        if (typeof customerBase !== 'string') {
            console.error('validate customer failed: base is not a string');
        }
        // Note: if this endpoint only receives a customer base it behaves
        // as a 'get' to fetch that customer despite the 'POST' verb usage
        var squibCall = "admin/squib_save_customer";
        var formData = new FormData();
        formData.append("c", "{\"base\" : \"" + customerBase + "\"}");
        var post = service.post(squibCall, formData, {
            withCredentials: true,
        });
        return post.then(function (response) {
            var data = response.data;
            if (!data) {
                return false;
            }
            var body = data.body;
            if (!body) {
                return false;
            }
            var customer = body.customer;
            if (!customer) {
                return false;
            }
            if (_.isEmpty(customer.phone)) {
                return false;
            }
            return true;
        }).catch(function (err) {
            return false;
        });
    }
};
export default customerService;



//////////////////
// WEBPACK FOOTER
// ./src/services/customer.service.ts
// module id = a5YG
// module chunks = 18